/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Equal_Crazy_Scallop_PinchInputs */

const fr_equal_crazy_scallop_pinch = /** @type {(inputs: Equal_Crazy_Scallop_PinchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez une nouvelle catégorie pour organiser vos programmes`)
};

/**

* @param {Equal_Crazy_Scallop_PinchInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const equal_crazy_scallop_pinch = /** @type {((inputs?: Equal_Crazy_Scallop_PinchInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Equal_Crazy_Scallop_PinchInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_equal_crazy_scallop_pinch(inputs)
});